var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"text-caption text--secondary"},[_vm._v(" "+_vm._s(_vm.$t('Fields marked with * are required.'))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }